import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import * as common from "common";
import sidebarItems from "assets/data/sidebarItems";
// import { useSelector } from "react-redux";
// import { selectapp } from "stateMgmt/appSlice";
import { v4 as uuid } from "uuid";
// import logger from "services/LoggingService";

import "./DropDownNavMenu.scss";

const DropDownNavMenu = (props) => {
  // const appContext = useSelector(selectapp).context;
  // const [isHidden, setIsHidden] = useState(true);
  let urlToUse = null;
  if (common.useMicrostrategyDev()) {
    urlToUse = "externalLinkDevURL";
  } else {
    urlToUse = "externalLinkProdURL";
  }

  let drawerClasses = "drop-down-menu";
  if (props.show) {
    drawerClasses = "drop-down-menu open";
  }

  useEffect(() => {
    // const hide = appContext !== "home";
    // setIsHidden(hide);
  });

  return (
    <nav className={drawerClasses} aria-hidden={true} aria-disabled={true}>
      {/* START: SideNav */}
      <ul data-testid="drop-nav" className="nav flex-column dropdown-ul">
        {sidebarItems.map((sidebarItem, sidebarItemIndex) =>
          typeof sidebarItem.externalLinkDevURL === "undefined" ? (
            <li
              className="nav-item liStyles nav-line"
              key={uuid()}
              tabIndex={-1}
              aria-disabled={true}
            >
              <NavLink
                aria-disabled={true}
                tabIndex={-1}
                className="text-muted dropdown-nav-link"
                key={uuid()}
                onClick={props.dropDownMenuClickHandler}
                to={sidebarItem.routePath}
                exact={"true"}
              >
                {sidebarItem.name}
              </NavLink>
            </li>
          ) : (
            <li
              className="nav-item liStyles nav-line"
              key={uuid()}
              tabIndex={-1}
              aria-disabled={true}
            >
              <a
                aria-disabled={true}
                tabIndex={-1}
                target="_blank"
                rel="noopener noreferrer dropdown-anchor"
                key={uuid()}
                className="text-muted dropdown-nav-link"
                href={sidebarItem[urlToUse]}
              >
                {sidebarItem.name}
              </a>
            </li>
          )
        )}
      </ul>
      {/* END: SideNav */}
    </nav>
  );
};

DropDownNavMenu.propTypes = {
  show: PropTypes.bool.isRequired,
  dropDownMenuClickHandler: PropTypes.func.isRequired,
};
export default DropDownNavMenu;
